import { render, staticRenderFns } from "./AccountHolderDebitCards.vue?vue&type=template&id=8853497e"
import script from "./AccountHolderDebitCards.vue?vue&type=script&lang=ts"
export * from "./AccountHolderDebitCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports